export const version = '2.10.7';
//# sourceMappingURL=version.js.map